<template>
  <div class="content-wrapper">
    <div class="content-lookup">
      <div class="lookup-left">
        <ul class="lookup-condition">
          <li class="field">
            <div class="title">
              회원명
            </div>
            <ul class="content">
              <li class="item">
                <input-text ref="searchMemberName" v-model="searchOption.memberName"/>
              </li>
            </ul>
          </li>
          <li class="field memberNameNumber">
            <div class="title">
              핸드폰 뒤자리
            </div>
            <ul class="content">
              <li class="item">
                <input-text
                    placeholder="핸드폰 뒤 4자리"
                    maxlength="4"
                    v-model="searchOption.endOfHpNumber"
                />
              </li>
            </ul>
          </li>
          <li class="field">
            <ul class="content">
              <li class="item">
                <ul class="check">
                  <li>
                    <label>
                      <input
                          type="checkbox"
                          v-model="searchOption.validFlag"
                      />
                      <i></i>
                      <div class="label">유효회원</div>
                    </label>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
        <div class="lookup-lookup">
          <erp-button
              button-div="GET"
              :is-shortcut-button="true"
              v-on:click.native="lookupPart().apiGetResponse()"
          >
            조회
          </erp-button>
        </div>
      </div>
    </div>
    <div class="content-body">
      <!--      <ReportView ref="reportViewComponent" :isPopup="true"/>-->
      <article class="body-article">
        <!-- 아코디언 : accordion / 닫힘 : close -->
        <section class="article-section">
          <div class="section-header">
            <div class="header-left">
              <div class="header-title">회비권 내역</div>
              <div class="header-caption">
                [{{ numberWithCommas(count) }} 건]
              </div>
            </div>
            <div class="header-right">
              <ul class="header-button">
                <li class="print">
                  <erp-button
                      button-div="FILE"
                      @click.native="excel"
                  >
                    Excel
                  </erp-button>
                </li>
              </ul>
            </div>
          </div>
          <div class="section-body">
            <ejs-grid-wrapper
                ref="gridTemplate"
                v-bind="gridSetting"
                :data-source="dataSource"
                :allowExcelExport="true"
                :allowSorting="true"
                :allowFiltering="true"
                :allowPaging="true"
                @queryCellInfo="gridMethods().onQueryCellInfo($event)"
                @actionComplete="gridMethods().onActionComplete($event)"
                @recordClick="gridMethods().onRecordClick($event)"
            />
            <!--:allowResizing="true"-->
            <!--:allowGrouping="true" -->
            <!--:allowDeleting="true"-->

          </div>
        </section>
      </article>
    </div>
  </div>
</template>

<style scoped>
body .appContent .body-article .section-body {overflow: hidden; border: none;}
</style>

<script>
import { numberWithCommas } from "@/utils/number";
import {Filter, Sort, ExcelExport,Page} from '@syncfusion/ej2-vue-grids';
import ejsGridWrapper from '@/components/common/EjsGridWrapper.vue';
import confirmDialogMixin from '@/views/layout/mixin/messagePopupDialogMixin';
import ErpButton from "@/components/button/ErpButton.vue";
// import ReportView from '@/components/common/report/ReportView';
import {mapGetters} from "vuex";
import InputText from "@/components/common/text/InputText.vue";
import {gridUtilGetMemberNoColumnAccess, gridUtilGetTelColumnAccess} from "@/utils/gridUtil";
// TODO 주석풀기
import GolfErpAPI from '@/api/v2/GolfErpAPI';
// import { commonCodesGetCommonCode,} from '@/utils/commonCodes';

export default {
  name: 'commonTemplate',
  components: {
    InputText,
    ejsGridWrapper,
    ErpButton,
    // ReportView
  },
  mixins: [confirmDialogMixin],
  mounted() {
    this.init();
  },
  computed:{
    ...mapGetters(['username']),
  },
  data() {
    return {
      searchOption: {memberNo:'' , memberName:'', endOfHpNumber:'', validFlag :false},
      dataSource: [],
      count:0,
      gridSetting: {
        columns: [
          {field: 'annualFeeId', type: 'string', isPrimaryKey: true, visible: false,},
          {field: 'memberNo', headerText: '회원번호', type: 'string', valueAccessor: (field, data) => gridUtilGetMemberNoColumnAccess(field, data), width: 100, textAlign: 'center',},
          {field: 'memberName', headerText: '회원명', type: 'string',width: 180, textAlign: 'center',},
          {field: 'hpNo', headerText: '핸드폰번호', type: 'string',width: 120, textAlign: 'center',   valueAccessor:(field, data) => data[field] ? this.contactTelValueAccess(field,data) : '-',},
          {
            headerText: "잔여라운딩",
            columns: [
              {field: 'remainWeekdayGolf', textAlign: 'right', width: 70, visible: true, allowEditing: true, type: 'number', headerText: '주중', isNumericType: true, inputNumberProperty: {allowDot: false, maxUnderDotLength: 0},},
              {field: 'remainWeekendGolf', textAlign: 'right', width: 70, visible: true, allowEditing: true, type: 'number', headerText: '주말', isNumericType: true, inputNumberProperty: {allowDot: false, maxUnderDotLength: 0},},
            ]
          },
          {
            headerText: "잔여숙박",
            columns: [
              {field: 'remainWeekdayStay', textAlign: 'right', width: 70, visible: true, allowEditing: true, type: 'number', headerText: '주중', isNumericType: true, inputNumberProperty: {allowDot: false, maxUnderDotLength: 0},},
              {field: 'remainWeekendStay', textAlign: 'right', width: 70, visible: true, allowEditing: true, type: 'number', headerText: '주말', isNumericType: true, inputNumberProperty: {allowDot: false, maxUnderDotLength: 0},},
            ]
          },
          {field: 'annualFeeStatus', headerText: '회원권상태', type: 'string', valueAccessor: (field, data) => {
            const statusMap = {
              'VALID': '이용',
              'EXPIRED': '만료'
            };
            return statusMap[data.annualFeeStatus] || '소진';
          }, width: 95, textAlign: 'center',},
          {
            headerText: "회원권 정보",
            columns: [
              {field: 'expirDateFrom', headerText: '시작일', type: Date, width: 110, textAlign: 'center',},
              {field: 'expirDateTo', headerText: '종료일', type: Date, width: 110, textAlign: 'center',},
            ]
          },
          
          {
            headerText: "라운딩",
            columns: [
              {field: 'weekdayGolf2', textAlign: 'right', width: 70, visible: true, allowEditing: true, type: 'number', headerText: '주중', isNumericType: true, inputNumberProperty: {allowDot: false, maxUnderDotLength: 0},},
              {field: 'weekendGolf2', textAlign: 'right', width: 70, visible: true, allowEditing: true, type: 'number', headerText: '주말', isNumericType: true, inputNumberProperty: {allowDot: false, maxUnderDotLength: 0},},
            ]
          },
          {
            headerText: "숙박",
            columns: [
              {field: 'weekdayStay2', textAlign: 'right', width: 70, visible: true, allowEditing: true, type: 'number', headerText: '주중', isNumericType: true, inputNumberProperty: {allowDot: false, maxUnderDotLength: 0},},
              {field: 'weekendStay2', textAlign: 'right', width: 70, visible: true, allowEditing: true, type: 'number', headerText: '주말', isNumericType: true, inputNumberProperty: {allowDot: false, maxUnderDotLength: 0},},
            ]
          },
        ],
        provides: [ ExcelExport,Filter, Sort, Page], //Edit, ForeignKey, Resize, Page, ExcelExport, Aggregate, Filter, Sor
        selectionSettings: { type: "Single", mode: "Both", enableToggle: false },
        pageSettings: {
          pageSize: 50
        }
      }
    };
  },
  methods: {
    numberWithCommas,
    contactTelValueAccess: gridUtilGetTelColumnAccess,
    init() {
      this.lookupPart().apiGetResponse();
    },
    excel() {
      this.$refs.gridTemplate.excelExport();
    },
    lookupPart() {
      const apiGetResponse = async (args) => {
        const response = await GolfErpAPI.fetchMembershipAnnualFeeList({
          memberNo: this.searchOption.memberNo,
          memberName: this.searchOption.memberName,
          endOfHpNumber:this.searchOption.endOfHpNumber,
          validFlag: this.searchOption.validFlag ? 1 : 0,
        });
        this.dataSource = response.map(item => {
          item.weekdayGolf2 = item.useWeekdayGolf +"/" + item.weekdayGolf;
          item.weekendGolf2 = item.useWeekendGolf +"/" + item.weekendGolf;
          item.weekdayStay2 = item.useWeekdayStay +"/" + item.weekdayStay;
          item.weekendStay2 = item.useWeekendStay +"/" + item.weekendStay;

          item.remainWeekdayGolf = item.weekdayGolf - item.useWeekdayGolf;
          item.remainWeekendGolf = item.weekendGolf - item.useWeekendGolf;

          item.remainWeekdayStay = item.weekdayStay - item.useWeekdayStay;
          item.remainWeekendStay = item.weekendStay - item.useWeekendStay;

          return item;
        });
      };
      return {apiGetResponse};
    },
    gridMethods() {
      const onQueryCellInfo = (args) => {};
      const onActionComplete = () => {
        this.count = numberWithCommas(
            this.$refs.gridTemplate?.getGridBatchCount() || 0
        );
      };
      const onRecordClick = () => {};
      return {onQueryCellInfo,onActionComplete,onRecordClick};
    },

  }
};
</script>
